import { lectio } from '../api';
import ActionTypes from '../constants/ActionTypes';
import { areArticlesLoaded, isArticleLoaded, isCategoryLoaded } from '../selectors';
import { fetchTopic } from './topic';

export const fetchArticle = key => {
  return async (dispatch, getState) => {
    if (isArticleLoaded(getState(), key)) return;

    try {
      const { data: article } = await lectio.get(`/article/${key}`);

      if (article.categoryKey) {
        await dispatch(fetchCategory(article.categoryKey));
      }
      await Promise.all(
        [article.topicKey, ...article.secondaryTopics].map(topic => dispatch(fetchTopic(topic)))
      );

      return dispatch({
        type: ActionTypes.FETCH_ARTICLE_SUCCESS,
        payload: article
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return dispatch({
          type: ActionTypes.FETCH_ARTICLE_NOT_FOUND,
          payload: { key }
        });
      }
      return dispatch({
        type: ActionTypes.FETCH_ARTICLE_ERROR,
        payload: { key }
      });
    }
  };
};

export const fetchCategory = key => {
  return async (dispatch, getState) => {
    if (isCategoryLoaded(getState(), key)) return;

    const { data: category } = await lectio.get(`/category/${key}`);
    return dispatch({
      type: ActionTypes.FETCH_CATEGORY_SUCCESS,
      payload: category
    });
  };
};

export const fetchArticles = (params: any = {}) => {
  return async (dispatch, getState) => {
    if (areArticlesLoaded(getState())) return;

    dispatch({
      type: ActionTypes.FETCH_ARTICLES_REQUEST,
      payload: {
        key: 0,
        params
      }
    });

    try {
      const { q, page: currentPage } = params;
      const { data } = await lectio.get(`/articles/list`, {
        params: { q, page: currentPage }
      });
      const { articles, page, perPage, totalArticles } = data;

      Object.values(articles).forEach((article: object) =>
        dispatch({
          type: ActionTypes.FETCH_ARTICLE_SUCCESS,
          payload: { ...article, partial: true }
        })
      );

      dispatch({
        type: ActionTypes.FETCH_ARTICLES_SUCCESS,
        payload: {
          key: 0,
          page,
          perPage,
          totalArticles,
          params
        }
      });
    } catch (ex) {
      dispatch({
        type: ActionTypes.FETCH_ARTICLES_ERROR,
        payload: {
          key: 0,
          params
        }
      });
    }
  };
};
